export enum WorkPackageStatus {
    ACTIVE = 'active',
    IN_PROGRESS = 'inProgress',
    ARCHIVED = 'archived',
}
